
import React from 'react';

const ContactForm: React.FC = () => {
  return (
    <div className="bg-gray-900 p-6 rounded-lg">
      <div className="elfsight-app-b2582d3f-f230-4eb0-aabc-eec0745fba11" data-elfsight-app-lazy></div>
    </div>
  );
};

export default ContactForm;
